/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Title } from "@mantine/core";
import React, { ReactNode } from "react";

type BenchPaperProps = {
  title: string;
  children?: ReactNode;
  width?: string;
  icon?: ReactNode; // ✅ FIX: allow React elements (icons, etc.)
};

const BenchPaper: React.FC<BenchPaperProps> = ({
  title,
  children,
  width,
  icon,
}) => {
  return (
    <div
      css={css`
        position: relative;
        margin: 20px auto;
        width: ${width || "100%"};
        box-shadow: -6px 12px 8px -8px rgba(0, 0, 0, 0.08);
        transition: box-shadow 0.3s ease, transform 0.2s ease;
      `}
    >
      {/* Header Section */}
      <div
        css={css`
          display: flex;
          align-items: center;
        `}
      >
        <div
          css={css`
            background: rgba(255, 255, 255, 1);
            color: #333;
            border-radius: 8px 0 0 0;
            padding: 12px 60px 12px 23px;
            margin-right: 6px;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 8px;
            transition: all 0.3s ease;
            position: relative;
            clip-path: polygon(0 0, 80% 0, 100% 100%, 0% 100%);
          `}
        >
          {/* ✅ Show icon beside title */}
          {icon && <>{icon}</>}
          <Title order={5}>{title}</Title>
        </div>
      </div>

      {/* Content Section */}
      <div
        css={css`
          position: relative;
          width: 100%;
          background: rgba(255, 255, 255, 1);
          border-radius: 0px 8px 8px 8px;
          margin-top: -1px;
          padding: 20px;
          text-align: left;
          transition: all 0.3s ease;
        `}
      >
        {children}
      </div>
    </div>
  );
};

export default BenchPaper;
